import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { Constant } from '../constant/constant';
import { CrmsettingsService } from './crmsettings.service';
import { EcryptServiceService } from '../core/auth/EcryptionService/ecrypt-service.service';
import { SendMessageResponse } from '../pages/internal-chat-bot/internal-chat-bot.component';
@Injectable({
  providedIn: 'root'
})
export class WhatsappChatService {


  url = environment.serverAPI8 + "/api/whatsapp";
  url1 = environment.serverAPI8 + "/api";

  whatsappVendorId: any;
  crmSettingsData: any;

  constructor(private http: HttpClient, private crmsettingsService: CrmsettingsService,
    private ecryptService: EcryptServiceService,) {

  }

  getAllWhatsAppChat(contactUid, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/view/${contactUid}?page=${Page}&size=${size}&sort=${sort}`);
  }

  /**
   * Paginated chat history for infinite scroll (older messages).
   * Returns Spring Page: { content: WhatsappMessageLog[], last: boolean, number: int, totalElements: int }
   */
  getChatHistoryByContactId(contactId: number, page: number, size: number): Observable<any> {
    return this.http.get(`${this.url}/chat-history/${contactId}?page=${page}&size=${size}`);
  }

  // Fetch message(s) by UID — backend: GET /api/whatsapp/messages?uid={uid}
  getMessageByUid(uid: string): Observable<any> {
    return this.http.get(`${this.url}/messages?uid=${encodeURIComponent(uid)}`);
  }



  getContactsData(
    page: number = 0,
    size: number = 20,
    sort: string = 'createdAt,desc',
    commonContactUid: any
  ): Observable<{ contacts: any[], nextPage: number }> {

    let accessToken = null;
    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);
      console.log("CRM Settings Data:", this.crmSettingsData);
      accessToken = this.ecryptService.encrypt(this.crmSettingsData.whatsappToken);
      console.log(accessToken);
    }


    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort);


    return this.http.get<{ contactsPaginatePage: number, contacts: any[] }>(
      `${this.url}/contacts-data/${commonContactUid}/null`,
      { params }
    ).pipe(
      map(response => ({
        contacts: response.contacts,
        nextPage: response.contactsPaginatePage
      }))
    );
  }

  sendMessage(MessageData: any, vendorId: number): Observable<Response[]> {

    let accessToken = null;
    let whatsappUrl = null;
    let currentPhoneNumberId = null;
    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);

      accessToken = this.ecryptService.encrypt(this.crmSettingsData.act);
      console.log(accessToken);
      currentPhoneNumberId = this.ecryptService.encrypt(this.crmSettingsData.currentPhoneNumberId);
    }

    let params = new HttpParams();

    return this.http.post<Response[]>(`${this.url}/sendNew`, MessageData);
  }
  sendMedia(MessageData: any): Observable<Response[]> {

    let accessToken = null;
    let whatsappUrl = null;
    let currentPhoneNumberId = null;
    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);

      accessToken = this.ecryptService.encrypt(this.crmSettingsData.act);
      console.log(accessToken);
      currentPhoneNumberId = this.ecryptService.encrypt(this.crmSettingsData.currentPhoneNumberId);
    }

    let params = new HttpParams();
    params = params
      .set('act', accessToken)
      .set('cpid', currentPhoneNumberId)


    return this.http.post<Response[]>(`${this.url}/send-media`, MessageData, { params });
  }
  sendMediaChat(MessageData: any): Observable<Response[]> {
    let params = new HttpParams();
    return this.http.post<Response[]>(`${this.url}/send-media`, MessageData);
  }

  getMessagesbyPhoneno(phoneno): Observable<Object> {
    return this.http.get(`${this.url}/chatView/${phoneno}`);
  }

  getBlockedUsers(): Observable<Object> {
    return this.http.get(`${this.url1}/blockList`);
  }

  getVendorId(): Observable<Object> {
    return this.http.get(`${this.url1}/vendor/id`);
  }

  getReplyMode(vendorUidOrId?: any): Observable<any> {
    return this.http.get(`${environment.serverAPI8}/api/vendor/reply-mode`).pipe(
      catchError(() => {
        if (vendorUidOrId) {
          return this.http.get(`${environment.serverAPI8}/webhook/settings/${vendorUidOrId}/reply-mode`);
        }
        return of(null);
      })
    );
  }

  setReplyMode(vendorUidOrId: any, mode: string): Observable<any> {
    return this.http.post(`${environment.serverAPI8}/api/vendor/reply-mode`, { mode }).pipe(
      catchError(() => {
        if (vendorUidOrId) {
          return this.http.post(`${environment.serverAPI8}/webhook/settings/${vendorUidOrId}/reply-mode`, { mode });
        }
        return of(null);
      })
    );
  }

  getContactsDataWithSearch(
    page: number = 0,
    size: number = 20,
    sort: string = 'createdAt,desc',
    commonContactUid: any,
    whatsappVendorId: any,
    search: string = ''
  ): Observable<{ contacts: any[], nextPage: number }> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort);

    if (search && search.trim().length > 0) {
      params = params.set('search', search.trim());
    }

    return this.http.get<{ contactsPaginatePage: number, contacts: any[] }>(
      `${this.url}/contacts-data/${commonContactUid}/null`,
      { params }
    ).pipe(
      map(response => ({
        contacts: response.contacts,
        nextPage: response.contactsPaginatePage
      }))
    );
  }



  getInternalContactsData(
    page: number = 0,
    size: number = 20,
    sort: string = 'createdAt,desc'
  ): Observable<{ contacts: any[], nextPage: number }> {

    let accessToken = null;
    const encrypted = localStorage.getItem('crmSettingsData');

    let commonContactUid = localStorage.getItem('userId')

    // let commonContactUid = 1845;
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);
      console.log("CRM Settings Data:", this.crmSettingsData);
      accessToken = this.ecryptService.encrypt(this.crmSettingsData.whatsappToken);
      console.log(accessToken);
    }


    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort);


    return this.http.get<{
      chatData: any; contactsPaginatePage: number, contacts: any[]
    }>(
      `${this.url1}/chatlogs/view`,
      { params }
    ).pipe(
      map(response => ({
        contacts: response.chatData.contactDetails,
        nextPage: response.chatData.contactsPaginatePage
      }))
    );
  }

  getInternalContactsDataSearch(
    page: number = 0,
    size: number = 20,
    sort: string = 'createdAt,desc',
    search: string = ''
  ): Observable<{ contacts: any[], nextPage: number }> {

    let accessToken = null;
    const encrypted = localStorage.getItem('crmSettingsData');

    let commonContactUid = localStorage.getItem('userId')

    // let commonContactUid = 1845;
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);
      console.log("CRM Settings Data:", this.crmSettingsData);
      accessToken = this.ecryptService.encrypt(this.crmSettingsData.whatsappToken);
      console.log(accessToken);
    }


    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort);

    if (search && search.trim().length > 0) {
      params = params.set('search', search.trim());
    }

    return this.http.get<{
      chatData: any; contactsPaginatePage: number, contacts: any[]
    }>(
      `${this.url1}/chatlogs/view`,
      { params }
    ).pipe(
      map(response => ({
        contacts: response.chatData.contactDetails,
        nextPage: response.chatData.contactsPaginatePage
      }))
    );
  }

  getAllChat(contactUid): Observable<Object> {
    // let fromID= 1845;
    return this.http.get(`${this.url1}/chatlogs/history/${contactUid}`);
  }


  sendMessageInternal(MessageData: any, vendorId: number): Observable<Response[]> {

    //  let commonContactUid=1845;
    //  MessageData['fromUser']= commonContactUid;
    return this.http.post<Response[]>(`${this.url1}/chatlogs/send`, MessageData);
  }

  sendMediaChatInternal(MessageData: any): Observable<Response[]> {

    //  let commonContactUid=1845;
    //  MessageData['fromUser']= commonContactUid;
    return this.http.post<Response[]>(`${this.url1}/chatlogs/send-media`, MessageData);
  }

  getAllChatBot(vendorPhone, wa_id): Observable<Object> {
    return this.http.get(`${this.url1}/chatbot/${wa_id}/${vendorPhone}`);
  }


  updateRead(contactUid): Observable<Object> {
    return this.http.get(`${this.url1}/chatlogs/read/${contactUid}`);
  }

  sendMessageChatBot(MessageData: any, vendorId: number): Observable<SendMessageResponse> {
    return this.http.post<SendMessageResponse>(`${this.url1}/chatbot/`, MessageData);
  }

  getSupportContactsData(
    page: number = 0,
    size: number = 20,
    sort: string = 'createdAt,desc'
  ): Observable<{ contacts: any[], nextPage: number }> {

    let accessToken = null;
    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);
      console.log("CRM Settings Data:", this.crmSettingsData);
      accessToken = this.ecryptService.encrypt(this.crmSettingsData.whatsappToken);
      console.log(accessToken);
    }


    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort);


    return this.http.get<{ contactsPaginatePage: number, contacts: any[] }>(
      `${this.url1}/support-contacts-data/0/null`,
      { params }
    ).pipe(
      map(response => ({
        contacts: response.contacts,
        nextPage: response.contactsPaginatePage
      }))
    );
  }
  getSupportContactsDataSearch(
    page: number = 0,
    size: number = 20,
    sort: string = 'createdAt,desc',
    commonContactUid: any,
    searchTerm: string
  ): Observable<{ contacts: any[], nextPage: number }> {

    let accessToken = null;
    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);
      console.log("CRM Settings Data:", this.crmSettingsData);
      accessToken = this.ecryptService.encrypt(this.crmSettingsData.whatsappToken);
      console.log(accessToken);
    }


    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort);
    if (searchTerm && searchTerm.trim().length > 0) {
      params = params.set('search', searchTerm.trim());
    }

    return this.http.get<{ contactsPaginatePage: number, contacts: any[] }>(
      `${this.url1}/support-contacts-data/${commonContactUid}/null`,
      { params }
    ).pipe(
      map(response => ({
        contacts: response.contacts,
        nextPage: response.contactsPaginatePage
      }))
    );
  }


  sendMessageFromVendor(MessageData: any): Observable<SendMessageResponse> {
    return this.http.post<SendMessageResponse>(`${this.url1}/chatbot/`, MessageData);
  }



  sendSupportMessage(MessageData: any, vendorId: number): Observable<Response[]> {

    let accessToken = null;
    let whatsappUrl = null;
    let currentPhoneNumberId = null;
    const encrypted = localStorage.getItem('crmSettingsData');
    // if (encrypted) {
    //   const decrypted = this.ecryptService.decryptionAES(encrypted);
    //   this.crmSettingsData = JSON.parse(decrypted);

    //   accessToken = this.ecryptService.encrypt(this.crmSettingsData.act);
    //   console.log(accessToken);
    //   currentPhoneNumberId = this.ecryptService.encrypt(this.crmSettingsData.currentPhoneNumberId);
    // }

    currentPhoneNumberId = "729877163537894";
    let params = new HttpParams();

    return this.http.post<Response[]>(`${this.url1}/support-chat-send`, MessageData);
  }

  getAllSupportChat(contactUid, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url1}/supportview/${contactUid}?page=${Page}&size=${size}&sort=${sort}`);
  }

  readUpdate(MessageData: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url1}/chatbot/readUpdate`, MessageData);
  }



  getAccountsDataSearch(MessageData: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url1}/chatbot/searchAccount`, MessageData);
  }

  createContactFromAccount(MessageData: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url1}/chatbot/createContact`, MessageData);
  }


  getAccountSettings(): Observable<Response[]> {
    return this.http.get<Response[]>(`${this.url1}/chatbot/account`);
  }


  sendTemplateMessage(contactUid: string, vendorId: number, data: any, headerImage?: File): Observable<any> {
    const formData = new FormData();

    formData.append('data', JSON.stringify(data));
    if (headerImage) {
      console.log(headerImage);
      formData.append('headerImage', headerImage, headerImage.name);
    }
    let accessToken = null;
    let whatsappUrl = null;
    let currentPhoneNumberId = null;
    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);

      accessToken = this.ecryptService.encrypt(this.crmSettingsData.act);
      console.log(accessToken);
      currentPhoneNumberId = this.ecryptService.encrypt(this.crmSettingsData.currentPhoneNumberId);
    }

    let params = new HttpParams();

    if (vendorId != null) {
      params = params
        .set('act', accessToken)
        .set('cpid', currentPhoneNumberId)
        .set('vendorId', vendorId.toString());
    }

    const url = `${this.url1}/chatbot/send-template-message/${contactUid}`;

    return this.http.post(url, formData, { params });
  }


  deleteByChatWaId(contactWaId: any): Observable<Object> {
    return this.http.delete(`${this.url1}/chatbot/deletechat/${contactWaId}`);
  }


  /**
   * Fetches a WhatsApp media attachment and returns an Observable<string> that
   * resolves to an object URL (blob: ...) safe to use as an <img> src.
   *
   * For Lookaside / Facebook CDN URLs the request is routed through our backend
   * proxy which fetches the image with the vendor's access token, avoiding CORS
   * and 401 issues.  The x-tenant header is sent so the backend can resolve the
   * correct vendor settings.
   */
  getImageByUrl(url: string): Observable<string> {
    if (
      url.includes('lookaside.fbsbx.com') ||
      url.includes('fbsbx.com') ||
      url.includes('whatsapp_business/attachments') ||
      url.includes('scontent.whatsapp.net') ||
      url.includes('fbcdn.net')
    ) {
      return this.http
        .get(`${environment.serverAPI8}/api/whatsapp/download-media/image?url=${encodeURIComponent(url)}`, {
          responseType: 'blob'
        })
        .pipe(
          map((blob: Blob) => URL.createObjectURL(blob))
        );
    } else {
      return this.http
        .get(url, { responseType: 'blob' })
        .pipe(
          map((blob: Blob) => URL.createObjectURL(blob))
        );
    }
  }

  /** Reads the c-id cookie value (tenant ID) — same logic used in components. */
  private getTenantIdFromCookie(): string {
    const name = 'c-id=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(name) === 0) {
        return c.substring(name.length);
      }
    }
    // Fallback: check localStorage key used by the interceptor
    return localStorage.getItem(Constant.enterPriseKey) || '';
  }

}
